import { useContext, useMemo } from 'react';
import UnlockTimerContext from '~/context/vdp/UnlockTimerContext';
import useAlertStatus from '~/hooks/vdp/selectors/useAlertStatus';
import useIsReservableVehicle from '~/hooks/vdp/selectors/useIsReservableVehicle';
import useIsVehicleReservedByOther from '~/hooks/vdp/selectors/useIsVehicleReservedByOther';

export enum VehicleNotifyStatus {
  ON_HOLD = 'on hold',
  PURCHASE_PENDING = 'purchase pending',
  PRE_ORDER = 'pre-order',
  RESERVED = 'reserved'
}

export default function useNotifyAnalyticsStatus() {
  const { shouldShowTimer } = useContext(UnlockTimerContext);
  const { purchasePending } = useAlertStatus();
  const isReservable = useIsReservableVehicle();
  const isReservedByOther = useIsVehicleReservedByOther();

  return useMemo(() => {
    switch (true) {
      case isReservedByOther:
        return VehicleNotifyStatus.RESERVED;
      case shouldShowTimer:
        return VehicleNotifyStatus.ON_HOLD;
      case purchasePending:
        return VehicleNotifyStatus.PURCHASE_PENDING;
      case isReservable:
        return VehicleNotifyStatus.PRE_ORDER;
      default:
        return null;
    }
  }, [isReservable, isReservedByOther, purchasePending, shouldShowTimer]);
}
